var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V5H9.82843C9.29799 5 8.78929 5.21071 8.41421 5.58579L2.58579 11.4142C2.21071 11.7893 2 12.298 2 12.8284V14C2 14.5523 2.44772 15 3 15H8.12602C8.57006 16.7252 10.1362 18 12 18C13.8638 18 15.4299 16.7252 15.874 15H21C21.5523 15 22 14.5523 22 14V12.8284C22 12.298 21.7893 11.7893 21.4142 11.4142L15.5858 5.58579C15.2107 5.21071 14.702 5 14.1716 5H12.75V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 20C12.75 19.5858 12.4142 19.25 12 19.25C11.5858 19.25 11.25 19.5858 11.25 20V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V20Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7123 17.7123C16.0052 17.4195 16.4801 17.4195 16.773 17.7123L18.1872 19.1266C18.4801 19.4195 18.4801 19.8943 18.1872 20.1872C17.8943 20.4801 17.4194 20.4801 17.1265 20.1872L15.7123 18.773C15.4194 18.4801 15.4194 18.0052 15.7123 17.7123Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22699 17.7123C7.51989 17.4195 7.99476 17.4195 8.28765 17.7123C8.58055 18.0052 8.58055 18.4801 8.28765 18.773L6.87344 20.1872C6.58055 20.4801 6.10567 20.4801 5.81278 20.1872C5.51989 19.8943 5.51989 19.4195 5.81278 19.1266L7.22699 17.7123Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.fed8f428def6ba4beecc0ae113b94bd5.svg";
export { ForwardRef as ReactComponent };